document.addEventListener('DOMContentLoaded', () => {
    const quantityInput = document.querySelector('.quantity__input');
    const minusButton = document.querySelector('button[name="minus"]');
    const plusButton = document.querySelector('button[name="plus"]');

    // Exit if required elements are not found
    if (!quantityInput || !minusButton || !plusButton) {
        console.warn('Required quantity elements not found');
        return;
    }

    // Function to update the state of buttons
    const updateButtonState = () => {
        const quantity = parseInt(quantityInput.value);
        const min = parseInt(quantityInput.getAttribute('data-min')) || 1;
        const max = parseInt(quantityInput.getAttribute('data-cart-quantity')) || Infinity;

        // Disable minus button if quantity is at minimum
        if (quantity <= min) {
            minusButton.classList.add('disabled');
            minusButton.disabled = true;
        } else {
            minusButton.classList.remove('disabled');
            minusButton.disabled = false;
        }

        // Disable plus button if quantity is at maximum
        if (quantity >= max) {
            plusButton.classList.add('disabled');
            plusButton.disabled = true;
        } else {
            plusButton.classList.remove('disabled');
            plusButton.disabled = false;
        }
    };

    // Initial state
    updateButtonState();

    // Event listeners for quantity change
    minusButton.addEventListener('click', () => {
        const quantity = parseInt(quantityInput.value);
        if (quantity > 1) {
            quantityInput.value = quantity - 1;
            updateButtonState();
        }
    });

    plusButton.addEventListener('click', () => {
        const quantity = parseInt(quantityInput.value);
        const max = parseInt(quantityInput.getAttribute('data-cart-quantity')) || Infinity;
        if (quantity < max) {
            quantityInput.value = quantity + 1;
            updateButtonState();
        }
    });

    quantityInput.addEventListener('input', () => {
        const value = Math.max(
            parseInt(quantityInput.getAttribute('data-min')) || 1,
            Math.min(
                parseInt(quantityInput.getAttribute('data-cart-quantity')) || Infinity,
                parseInt(quantityInput.value) || 1
            )
        );
        quantityInput.value = value;
        updateButtonState();
    });
});